import { HostHardware, HostPlatform } from '@ftr/contracts/regional-api'
import { AbstractClassBuilder, assertUnreachable } from '@ftr/foundation'

export function getOsSpecificHostHardware(platform: HostPlatform): HostHardware {
  switch (platform) {
    case HostPlatform.AIX:
    case HostPlatform.Android:
    case HostPlatform.FreeBSD:
    case HostPlatform.Haiku:
    case HostPlatform.OpenBSD:
    case HostPlatform.SunOS:
    case HostPlatform.Cygwin:
    case HostPlatform.NetBSD:
    case HostPlatform.Linux:
    case HostPlatform.Windows:
      return {
        manafacturer: 'Dell Inc.',
        model: 'Vostro 16 5630',
      }
    case HostPlatform.Darwin:
      return {
        manafacturer: 'Apple Inc.',
        model: 'Mac14,9',
      }
    default:
      assertUnreachable(platform)
  }
}

export class HostHardwareBuilder extends AbstractClassBuilder<HostHardware> {
  constructor(platform: HostPlatform) {
    super(HostHardware, getOsSpecificHostHardware(platform))
  }
}
